import { t } from 'i18next';
import React from 'react';
import { Spinner } from 'react-bootstrap';

export const LoadingControl = ({ height = 38, text }: { height?: number; text?: string }) => {
  return (
    <div className="form-control bg-light d-flex align-items-center" style={{ height }}>
      <Spinner animation="border" size="sm" className="me-2" />
      <span className="text-muted small">{text || t('common.loading')}</span>
    </div>
  );
};
